(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vs-product-header"] && !Shopify.designMode) return;
  try {
    /*
    Product image viewer: clicking a gallery image opens it centred over a dimmed page
    with left/right arrows, like Dossier. Replaces Horizon's full-screen zoom on desktop
    and mobile; on phones you can also swipe between images.
  */
  (() => {
    // Photo badges (gender/Bestseller, deal badge) and breadcrumb are shown as COPIES inside the
    // gallery that is actually visible (Horizon has a phone slideshow and a desktop grid).
    // The originals stay hidden in this block. When a size is picked, Horizon redraws the gallery
    // and/or this block, so the copies are checked and put back automatically.
    const visible = (el) => !!el && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
    const sync = () => {
      document.querySelectorAll('[data-vs-gallery-badges], [data-vs-gallery-crumbs]').forEach((src) => {
        if (src.dataset.vsClone) return;
        const scope = src.closest('.shopify-section') || document;
        const gallery = scope.querySelector('media-gallery');
        if (!gallery) return;
        const options = [...gallery.querySelectorAll('slideshow-component, .media-gallery__grid')];
        const target = options.find(visible) || options[0] || gallery;
        const key = src.classList[0];
        const html = src.innerHTML;
        const here = target.querySelector(`:scope > [data-vs-clone="${key}"]`);
        if (here && here.dataset.vsHtml === String(html.length) + ':' + src.className) return;
        gallery.querySelectorAll(`[data-vs-clone="${key}"]`).forEach((old) => old.remove());
        const copy = src.cloneNode(true);
        copy.dataset.vsClone = key;
        copy.dataset.vsHtml = String(html.length) + ':' + src.className;
        copy.removeAttribute('data-vs-gallery-badges');
        copy.removeAttribute('data-vs-gallery-crumbs');
        copy.hidden = false;
        if (getComputedStyle(target).position === 'static') target.style.position = 'relative';
        target.appendChild(copy);
      });
    };
    let syncTimer;
    const queue = () => { clearTimeout(syncTimer); syncTimer = setTimeout(sync, 60); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
    else sync();
    window.addEventListener('load', sync);
    document.addEventListener('shopify:section:load', queue);
    window.matchMedia('(min-width: 750px)').addEventListener('change', queue);
    // size/variant change: Horizon swaps parts of the page, so re-check whenever the page changes
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
    // Scent families sheet
    document.addEventListener('click', (e) => {
      if (!(e.target instanceof Element)) return;
      const opener = e.target.closest('[data-vs-families-open]');
      if (opener) {
        const d = document.getElementById(opener.dataset.vsFamiliesOpen);
        if (d && d.showModal) { if (d.parentElement !== document.body) document.body.appendChild(d); d.showModal(); }
        return;
      }
      if (e.target.closest('[data-vs-close-fam]')) { e.target.closest('dialog')?.close(); return; }
      const dealOpener = e.target.closest('[data-vs-deal-open]');
      if (dealOpener) {
        e.preventDefault();
        const d = document.getElementById(dealOpener.dataset.vsDealOpen);
        if (d && d.showModal) { if (d.parentElement !== document.body) document.body.appendChild(d); d.showModal(); }
        return;
      }
      if (e.target.closest('[data-vs-close-deal]')) { e.target.closest('dialog')?.close(); return; }
      if (e.target instanceof HTMLDialogElement && e.target.classList.contains('vs-dealsheet')) { e.target.close(); return; }
      if (e.target instanceof HTMLDialogElement && e.target.classList.contains('vs-fam')) e.target.close();
    });
    // Back arrow: return to the previous page on this shop, otherwise go to the gender collection
    document.addEventListener('click', (e) => {
      const back = e.target instanceof Element ? e.target.closest('[data-vs-back]') : null;
      if (!back) return;
      if (document.referrer && new URL(document.referrer).origin === location.origin && history.length > 1) {
        e.preventDefault();
        history.back();
      }
    });
  })();

  (() => {
    if (window.__vsLightbox) return;
    window.__vsLightbox = true;

    // Slideshow layout: the image itself is clickable. Grid layout: a zoom button sits over each image.
    const TRIGGER = '.product-media-container--zoomable.product-media-container--image, .product-media-container__zoom-button';
    const ITEM = '.product-media-container--image';
    let box, img, list = [], index = 0, lastFocus = null;

    const bigUrl = (src) => {
      try {
        const url = new URL(src, location.href);
        if (!/^https?:$/.test(url.protocol)) return src;
        url.searchParams.set('width', '1800');
        url.searchParams.delete('height');
        return url.toString();
      } catch (e) { return src; }
    };

    const build = () => {
      box = document.createElement('div');
      box.className = 'vs-lightbox';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', 'Product image');
      box.hidden = true;
      box.innerHTML = `
        <button type="button" class="vs-lightbox__close" aria-label="Close">
          <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><path d="M3 3l12 12M15 3L3 15" stroke="currentColor" stroke-width="1.6"/></svg>
        </button>
        <button type="button" class="vs-lightbox__nav vs-lightbox__nav--prev" aria-label="Previous image">
          <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>
        </button>
        <figure class="vs-lightbox__stage"><img alt=""></figure>
        <button type="button" class="vs-lightbox__nav vs-lightbox__nav--next" aria-label="Next image">
          <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>
        </button>`;
      document.body.appendChild(box);
      img = box.querySelector('img');
      box.querySelector('.vs-lightbox__close').addEventListener('click', close);
      box.querySelector('.vs-lightbox__nav--prev').addEventListener('click', () => show(index - 1));
      box.querySelector('.vs-lightbox__nav--next').addEventListener('click', () => show(index + 1));
      box.addEventListener('click', (e) => { if (e.target === box) close(); });
      let startX = null;
      box.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
      box.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
      });
    };

    const show = (i) => {
      index = (i + list.length) % list.length;
      const source = list[index];
      img.src = bigUrl(source.currentSrc || source.src);
      img.alt = source.alt || '';
      box.querySelectorAll('.vs-lightbox__nav').forEach((b) => (b.hidden = list.length < 2));
    };

    const open = (images, i) => {
      if (!box) build();
      list = images;
      lastFocus = document.activeElement;
      show(i);
      box.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      box.querySelector('.vs-lightbox__close').focus();
    };

    const close = () => {
      if (!box || box.hidden) return;
      box.hidden = true;
      img.removeAttribute('src');
      document.documentElement.style.overflow = '';
      lastFocus?.focus?.();
    };

    // Capture phase: runs before Horizon's own zoom so its full-screen dialog doesn't open
    window.addEventListener('click', (e) => {
      if (!(e.target instanceof Element)) return;
      const trigger = e.target.closest(TRIGGER);
      if (!trigger || trigger.closest('dialog, .dialog-zoomed-gallery')) return;
      const item = trigger.closest(ITEM);
      if (!item) return;
      const gallery = item.closest('media-gallery') || item.parentElement;
      const items = [...gallery.querySelectorAll(ITEM)].filter(
        (el) => !el.closest('dialog, .dialog-zoomed-gallery') && el.getClientRects().length && el.querySelector('img') &&
          (el.matches('.product-media-container--zoomable') || el.querySelector('.product-media-container__zoom-button'))
      );
      const at = items.indexOf(item);
      if (at < 0) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      open(items.map((el) => el.querySelector('img')), at);
    }, true);

    document.addEventListener('keydown', (e) => {
      if (!box || box.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(index - 1);
      if (e.key === 'ArrowRight') show(index + 1);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
